export default __webpack_public_path__ + "static/media/Golang_microservice.0aaad9d9.png";